export enum InsuranceDailySalaryCalculationMethod {
Value,
ValueMultiplier,
Manual,
Expression,
}
